import { useMemo } from 'react';
import _ from 'lodash';
import { useApi } from './api';
import { getProxyUrl } from '../utils/image';

export const useTeam = (abbrv) => useApi(abbrv && `team?id=${abbrv}`);

export const useTeams = () => {
  const [data, loading, error] = useApi('league/teams');

  const sortedTeams = useMemo(() => _.sortBy(data, 'name', 'desc'), [data]);

  return [sortedTeams, loading, error];
};

export const useTeamLogo = (
  abbrv,
  { width = 50, height = 50, logoImageUrl } = {}
) => {
  const [team, loading, error] = useTeam(!logoImageUrl && abbrv);

  const logo =
    logoImageUrl || team?.logoImageUrl
      ? getProxyUrl(logoImageUrl || team.logoImageUrl, width, height)
      : '/wp-content/themes/sef-leagues/images/generic-team.png';

  return [logo, loading, error];
};

export const useTeamStaff = (abbrv) => useApi(`team/staff?id=${abbrv}`);
